import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const PromotionsBetaNotice = ({ compact = false }) => (
    <Box
        mt={compact ? 1 : 2}
        mb={compact ? 0 : 2}
        px={1.5}
        py={compact ? 1 : 1.25}
        style={{
            backgroundColor: '#F0FDF4',
            border: '1px solid #BBF7D0',
            borderRadius: 8,
        }}
    >
        <Typography
            variant="body2"
            style={{
                color: '#166534',
                fontSize: compact ? 12 : 13,
                lineHeight: 1.45,
            }}
        >
            Esta función estará disponible <strong>gratis</strong> durante los próximos{' '}
            <strong>3 meses</strong>.
        </Typography>
    </Box>
);

export default PromotionsBetaNotice;
